// assets.js
'use strict';
import { fromJS } from 'immutable';
import {
  MERGE_ASSET_DATA,
  REMOVE_ASSET_DATA,
  RESTORE_ASSET_DATA,
  MERGE_SSR_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Assets.
 * @module reducer/assets
 */
const assets = (state = defaultState, action) => {
  switch (action.type) {
    case MERGE_ASSET_DATA:
      return _MERGE_ASSET_DATA(action.payload)(state);
    case REMOVE_ASSET_DATA:
      return _REMOVE_ASSET_DATA(action.payload)(state);
    case RESTORE_ASSET_DATA:
      return _RESTORE_ASSET_DATA(action.payload)(state);
    case MERGE_SSR_DATA:
      return _MERGE_SSR_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Merge asset data
 * @kind reducer/actionType
 * @name MERGE_ASSET_DATA
 * @param {array} {selectPath} - select path
 * @param {any} {data} - data
 * @return {Immutable.Map} New state
 */
const _MERGE_ASSET_DATA =
  ({ selectPath, data }) =>
  state => {
    return state.mergeDeepIn(selectPath, data);
  };

/**
 * Remove asset data
 * @kind reducer/actionType
 * @name REMOVE_ASSET_DATA
 * @param {array} {selectPath} - select path
 * @return {Immutable.Map} New state
 */
const _REMOVE_ASSET_DATA =
  ({ selectPath }) =>
  state => {
    return state.deleteIn(selectPath);
  };

/**
 * Restore asset data
 * @kind reducer/actionType
 * @name RESTORE_ASSET_DATA
 * @param {object} assetData - asset data
 * @return {Immutable.Map} New state
 */
const _RESTORE_ASSET_DATA = assetData => state => {
  return state.mergeDeep(assetData);
};

/**
 * Merge ssr data
 * @kind reducer/actionType
 * @name MERGE_SSR_DATA
 * @param {object} payload - payload
 * @param {object} payload.assets - assets data from SSR
 * @return {Immutable.Map} New state
 */
const _MERGE_SSR_DATA =
  ({ assets }) =>
  state => {
    return state.mergeDeep(fromJS(assets));
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default assets;
